import { Checkbox, Form, Grid, Text, TextField } from '@approvalmax/ui/src/components';
import { domHelpers } from '@approvalmax/utils';
import { constants } from 'modules/common';
import { memo } from 'react';
import { useFormContext } from 'react-hook-form';

import { messages } from './AddressPart.messages';
import { AddressPartProps } from './AddressPart.types';

export const AddressPart = memo<AddressPartProps>((props) => {
    const { name, title, isSameCheckboxVisible, sameCheckboxTitle, sameCheckboxFormName, qa } = props;

    const form = useFormContext();

    const isSameAddress = form.watch(sameCheckboxFormName ?? '', false);

    return (
        <Form.Part>
            <div>
                <Grid gridTemplateColumns='max-content max-content' columnGap={16} padding='16 0'>
                    <Text color='midnight80' font='headline' fontSize='xxsmall' fontWeight='medium'>
                        {title}
                    </Text>

                    {isSameCheckboxVisible && <Checkbox name={sameCheckboxFormName}>{sameCheckboxTitle}</Checkbox>}
                </Grid>

                {!isSameAddress && (
                    <Grid rowGap={16}>
                        <Grid gridTemplateColumns='1fr 1fr' columnGap={16}>
                            <TextField
                                name={`${name}.attentionTo`}
                                label={messages.attention}
                                size='medium'
                                placeholder={messages.attentionPlaceholder}
                                maxLength={constants.xeroConstants.ADDRESS_ATTENTION_TO_MAX_LENGTH}
                                qa={domHelpers.generateDataQa(qa, 'attention-editor')}
                            />

                            <TextField
                                name={`${name}.city`}
                                label={messages.city}
                                size='medium'
                                placeholder={messages.cityPlaceholder}
                                maxLength={constants.xeroConstants.ADDRESS_CITY_MAX_LENGTH}
                                qa={domHelpers.generateDataQa(qa, 'city-editor')}
                            />
                        </Grid>

                        <Grid alignItems='flex-start' gridTemplateColumns='1fr 1fr' columnGap={16}>
                            <TextField
                                name={`${name}.address`}
                                label={messages.address}
                                size='medium'
                                multiline
                                minHeight={112}
                                autoHeight
                                placeholder={messages.addressPlaceholder}
                                maxLength={constants.xeroConstants.ADDRESS_MAX_LENGTH}
                                qa={domHelpers.generateDataQa(qa, 'address-editor')}
                            />

                            <Grid rowGap={16}>
                                <Grid gridTemplateColumns='1fr 1fr' columnGap={16}>
                                    <TextField
                                        name={`${name}.region`}
                                        label={messages.state}
                                        size='medium'
                                        placeholder={messages.statePlaceholder}
                                        maxLength={constants.xeroConstants.ADDRESS_REGION_MAX_LENGTH}
                                        qa={domHelpers.generateDataQa(qa, 'region-editor')}
                                    />

                                    <TextField
                                        name={`${name}.postalCode`}
                                        label={messages.postalCode}
                                        size='medium'
                                        placeholder={messages.postalCodePlaceholder}
                                        maxLength={constants.xeroConstants.ADDRESS_POST_CODE_MAX_LENGTH}
                                        qa={domHelpers.generateDataQa(qa, 'postal-code-editor')}
                                    />
                                </Grid>

                                <TextField
                                    name={`${name}.country`}
                                    label={messages.country}
                                    size='medium'
                                    placeholder={messages.countryPlaceholder}
                                    maxLength={constants.xeroConstants.ADDRESS_COUNTRY_MAX_LENGTH}
                                    qa={domHelpers.generateDataQa(qa, 'country-editor')}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                )}
            </div>
        </Form.Part>
    );
});

AddressPart.displayName = 'AddressPart';
